import { render, staticRenderFns } from "./DeliveryManForm.vue?vue&type=template&id=371fad1d&"
import script from "./DeliveryManForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryManForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports